import React from "react";
import "./App.css";
import Navbar from "./components/navbar/navbar";
import HeroSection from "./sections/heroSection/heroSection";
import AboutSection from "./sections/aboutSection/aboutSection";
import BioSection from "./sections/bioSection/bioSection";
import ProjectSection from "./sections/projectsSection/projectSection";
import ScrollVelocity from "./effects/ScrollVelocity";
import Footer from "./components/footer/footer";

function App() {
  return (
    <div>
      <Navbar />
      <HeroSection />
      <AboutSection />
      <BioSection />
      <ProjectSection />
      <ScrollVelocity />
      <Footer />
    </div>
  );
}

export default App;
